import axios from 'axios'
import { getDate, getDateWithBufor } from '../helpers/date.js'

export default {
    state: {
        brands: [
            {
                val: 'Jaguar',
                name: 'Jaguar',
                image: require('../assets/jaguar.jpg'),
                id: 48
            },
            {
                val: 'Land Rover',
                name: 'Land Rover',
                image: require('../assets/land-rover.jpg'),
                id: 56
            },
        ],
        dealers: [],
        models: [],
        services: [
            {
                val: 1,
                name: 'Olej silnikowy',
                text: 'Wymiana oleju silnikowego'
            },
            {
                val: 2,
                name: 'Płyn hamulcowy',
                text: 'Wymiana płynu hamulcowego'
            },
            {
                val: 3,
                name: 'Hamulce przednie',
                text: 'Serwis hamulców przednich / wymiana klocków'
            },
            {
                val: 4,
                name: 'Hamulce tylne',
                text: 'Serwis hamulców tylnych / wymiana klocków'
            },
            {
                val: 5,
                name: 'Wkład filtra powietrza',
                text: 'Serwis wkładu filtra powietrza'
            },
            {
                val: 6,
                name: 'Mikrofiltr',
                text: 'Przegląd / wymiana mikrofiltra(ów)'
            },
            {
                val: 7,
                name: 'Filtr paliwa',
                text: 'Serwis filtru paliwa'
            },
            {
                val: 8,
                name: 'Filtr obiegu powietrza',
                text: 'Przegląd / wymiana mikrofiltra(ów) obiegu powietrza'
            },
            {
                val: 9,
                name: 'Wymiana świec',
                text: 'Wymiana świec zapłonowych'
            },
            {
                val: 10,
                name: 'Wymiana kół / opon',
                text: 'Wymiana kół / opon'
            },
        ],
        replacementCars: [],
        timeOfday: [
            {
                val: 1,
                name: '09:00',
                term: {
                    hour_from: 9,
                    hour_to: 10
                }
            },
            {
                val: 2,
                name: '10:00',
                term: {
                    hour_from: 10,
                    hour_to: 11
                }
            },
            {
                val: 3,
                name: '11:00',
                term: {
                    hour_from: 11,
                    hour_to: 12
                }
            },
            {
                val: 4,
                name: '12:00',
                term: {
                    hour_from: 12,
                    hour_to: 13
                }
            },
            {
                val: 5,
                name: '13:00',
                term: {
                    hour_from: 13,
                    hour_to: 14
                }
            }
        ],
        localizationsOpenHours: [
            { // Poznań
                id: 1,
                hour_to: "18:30"
            },
            { // Warszawa
                id: 2,
                hour_to: "16:30"
            },
            { // Wrocek
                id: 3,
                hour_to: "18:30"
            },
            { // id 11
                id: 3,
                hour_to: "19:00"
            }
        ],
        replacementCarPrices: {
            1: 69, //Poznań
            2: 269, //Warszawa
            3: 100, //Wrocław,
            11: 269 //Warszawa
        },
        serviceTermMoving: {
            10: () => { //wymiana opon i kół

                let date = new Date();
                switch (date.getDay()) {
                    case 5: // piątek + 3 dni
                        date.setDate(date.getDate() + 3);
                        break;
                    case 6: // sobota + 2 dni
                        date.setDate(date.getDate() + 2);
                        break;
                    default: // Dni powszednie
                        date.setTime(date.getTime() + (48 * 60 * 60 * 1000));
                        break;
                }

                return date;

            },
            default: () => {

                let date = new Date();
                switch (date.getDay()) {
                    case 5: // piąteczek, piątunio
                        date.setDate(date.getDate() + 2);
                        break;
                    default: // Dni powszednie 
                        date.setTime(date.getDate() + 1);
                        break;
                }
                return date;

            }

        },
        detepickerConfig: {
            formatLocale: {
                // MMMM
                months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
                // MMM
                monthsShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
                // dddd
                weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
                // ddd
                weekdaysShort: ['Niedz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
                // dd
                weekdaysMin: ['Nd', 'Po', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
                // first day of week
                firstDayOfWeek: 1
            },
            range(date) {
                return this.$store.getters['definitions/getFirstPossibleDate'] > date || typeof this.$store.getters['definitions/getDetepickerDates'](date) == 'string'
            },
            disabledDays: [
                '01-01', // Nowy Rok
                '01-06', // Święto Trzech Króli
                '04-04', // Wielkanoc
                '04-05', // Poniedziałek Wielkanocny
                '05-01', // Święto Pracy
                '05-03', // Święto Konstytucji 3 Maja
                '05-23', // Zielone Świątki
                '06-03', // Boże Ciało
                '08-15', // Święto Wniebowzięcie Najświętszej Maryi Panny
                '11-01', // Wszystkich Świętych
                '11-11', // Święto Niepodległości
                '12-25', // Boże Narodzenie
                '12-26' // Boże Narodzenie
            ]
        },
        terms: [],
        termComparedTimeBufor: 29, // margines czasu dla doradcy (połowa godziny 30min)
    },
    getters: {
        getDealers: state => state.dealers,
        getBrands: state => state.brands,
        getModels: state => state.models,
        getServices: state => state.services,
        getReplacementCars: state => state.replacementCars,
        getTimeOfDay: state => state.timeOfday,
        getTerms: state => state.terms,
        getFirstPossibleDate: (state, getters, rootState, rootGetters) => {
            // sprawdzam i pobieram index reguły dla ostatniej wybranej usługi
            let serviceMovingIndex = Object.keys(state.serviceTermMoving).indexOf(String(rootGetters['lead/getLead'].services_val.slice(-1).pop()))
            // jak znalazło regułę to ją odpalam
            if (serviceMovingIndex >= 0) {
                var startDate = state.serviceTermMoving[Object.keys(state.serviceTermMoving)[serviceMovingIndex]]();
            } else { // jak nie to default
                var startDate = state.serviceTermMoving.default();
            }
            return startDate;
        },
        getDetepickerDates: (state) => (date) => { // zwraca datę jeżeli święto
            return new Date() > date || state.detepickerConfig.disabledDays.map(e => new Date(date.getFullYear() + "-" + e).toUTCString()).find(d => {
                return d == new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toUTCString()
            })
        },
        getDetepickerConfig: state => state.detepickerConfig,
    },
    mutations: {
        setDealers(state, payload) {
            state.dealers = payload;
        },
        setBrands(state, payload) {
            state.brands = payload
        },
        setModels(state, payload) {
            state.models = payload
        },
        setReplacementCars(state, payload) {
            state.replacementCars = payload;
        },
        setAvaibleTerms(state, payload) {
            state.avaibleTerms = payload;
        },
        setTerms(state, payload) { state.terms = payload }
    },
    actions: {
        async fetchDealers({ commit, state }, params) {
            const { data } = await axios.get('/dealers', {
                params: {
                    service: 1,
                    ...params
                }
            });
            commit('setDealers', data.dealers);
        },
        async fetchModels({ commit, state }, params) {
            const { data } = await axios.get('/car-models-all', {
                params: {
                    ...params,
                    limit: 10000
                }
            });
            commit('setModels', data.models);
        },
        async fetchServiceCars({ commit, state, rootState }, params) {
            const { data } = await axios.get('/service-cars', {
                params: {
                    dealer_id: rootState.lead.lead.dealer_id,
                    date: rootState.lead.lead.date,
                    hour: rootState.lead.lead.hour_from,
                    hour_to: rootState.lead.lead.hour_to,
                }
            });

            data.cars = data.cars.map(e => {
                return {
                    ...e,
                    price: state.replacementCarPrices[rootState.lead.lead.dealer_id]
                }
            })
            commit('setReplacementCars', data.cars);
        },
        async fetchServiceAdmissionTerms({ commit, state }, params = {}) {
            const { data } = await axios.get('/service-admission-terms', {
                params: {
                    ...params,
                    mechanic: 1,
                    mechanic_offset_min: state.termComparedTimeBufor,
                    days: 7,
                    mechanic_same_day: 1
                }
            });
            commit('setTerms', data.terms);
        },
    },
    namespaced: true
}